import React from 'react';

import './create-button.scss';

export default function CreateButton({ onSubmit }: { onSubmit: () => void }) {
    return (
        <button className="btn c-btn" onClick={onSubmit}>
            <i className="material-icons">add</i>
            <span>Create</span>
        </button>
    );
}
